
export class DeletedSale {
	ID:number = 0;
	SaleID:number = 0;
	ContactID:number = 0;
	DeletedDate:Date = new Date();
	ComputedFriendlyID:string = "";
	Trace:string = "";
	RawJson:string = "";
	DeletedByUserID:number = 0;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.SaleID = data.SaleID;
		this.ContactID = data.ContactID;
		this.DeletedDate = new Date(data.DeletedDate);
		this.ComputedFriendlyID = data.ComputedFriendlyID;
		this.RawJson = data.JsonData;
		// this.JsonData = new Sale(JSON.parse(data.JsonData));
		this.Trace = data.Trace;
		this.DeletedByUserID = data.DeletedByUserID;
	}
}